var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94501 3.19992L3.78751 9.71742C3.55501 9.96492 3.33001 10.4524 3.28501 10.7899L3.00751 13.2199C2.91001 14.0974 3.54001 14.6974 4.41001 14.5474L6.82501 14.1349C7.16251 14.0749 7.63501 13.8274 7.86751 13.5724L14.025 7.05492C15.09 5.92992 15.57 4.64742 13.9125 3.07992C12.2625 1.52742 11.01 2.07492 9.94501 3.19992Z",
    stroke: "#45AE51",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91748 4.2876C9.23998 6.3576 10.92 7.9401 13.005 8.1501",
    stroke: "#45AE51",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17H15.75",
    stroke: "#45AE51",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4fc4d47d088662fc62e464fd84139a44.svg";
export { ForwardRef as ReactComponent };